export default __webpack_public_path__ + "18a7191678e558c5519c3e330eff5f85.png";